module.exports = __webpack_public_path__ + "static/3ds_benefits3-ddffdffa1356661e543265687cf42be4.png";